// Servicios.js
import React from 'react';
import { FiPackage, FiTool, FiMap, FiZap, FiBatteryCharging, FiTruck, FiCheck } from 'react-icons/fi';
import suministrosImg from '../assets/suministros.png';
import obrasImg from '../assets/obras.png';
import vialidadImg from '../assets/vialidad.png';
import electricidadImg from '../assets/electricidad.png';
import materialesImg from '../assets/materiales.png';
import equiposImg from '../assets/equipos.png';

const servicios = [
  {
    titulo: 'Suministros, Servicios y Alquiler',
    icon: FiPackage,
    imagen: suministrosImg,
    items: [
      'Suministros de uniformes industriales y bragas petroleras',
      'Suministros de uniformes corporativos, comerciales y profesionales',
      'Suministro de equipo de higiene y seguridad personal',
      'Suministro de papelería y artículos de oficina',
      'Suministros de materiales de ferretería y construcción',
      'Suministros de pinturas (industriales, marítimas, comerciales y de vialidad)',
      'Suministro y accesorios de equipos de fotocopiadora y computación',
      'Suministros y accesorios de equipos médicos, quirúrgicos y odontológicos',
      'Suministros y accesorios de equipos deportivos y de recreación',
      'Servicio de traslados de personas',
      'Servicio de transporte de equipos industriales',
      'Servicio de transporte de mercancía comercial',
      'Servicio de consultoría y recursos humanos',
      'Alquiler de equipos médicos y odontológicos',
      'Alquiler de vehículos: camiones, camionetas, buses, vans, ambulancias',
      'Alquiler de tráiler y plantas de tratamiento de aguas residuales',
      'Alquiler de maquinarias livianas y pesadas'
    ]
  },
  {
    titulo: 'Servicios de Obras Civiles',
    icon: FiTool,
    imagen: obrasImg,
    items: [
      'Cálculos de proyectos civiles, mecánicos y sanitarios',
      'Topografía y planos de ingeniería',
      'Movimiento de tierras, excavaciones, carga y compactación',
      'Fundaciones, estructuras metálicas, vaciado de concreto',
      'Revestimientos, trabajos en altura, instalación de sistemas',
      'Transporte y tratamiento de aguas servidas y desechos petroleros'
    ]
  },
  {
    titulo: 'Vialidad',
    icon: FiMap,
    imagen: vialidadImg,
    items: [
      'Escarificación y análisis de suelos',
      'Colocación y compactación de asfalto',
      'Construcción de aceras y brocales',
      'Instalación de bases para postes',
      'Limpieza de drenajes con Vacum',
      'Demarcación y señalización vial'
    ]
  },
  {
    titulo: 'Servicios Eléctricos',
    icon: FiZap,
    imagen: electricidadImg,
    items: [
      'Diseño e instalación de redes en media y baja tensión',
      'Transformadores, seccionadores, descargadores, luminarias',
      'Canalizaciones, tableros, plantas eléctricas y transferencias',
      'Mantenimiento de equipos eléctricos',
      'Estudios de calidad, análisis de fallas y pruebas técnicas'
    ]
  },
  {
    titulo: 'Suministros Eléctricos',
    icon: FiBatteryCharging,
    imagen: materialesImg,
    items: [
      'Transformadores, postes, luminarias y herrajes',
      'Cables de diferentes calibres y tipos',
      'Plantas eléctricas y transferencias automáticas',
      'Fusibles y tableros eléctricos personalizados',
      'Capacitación técnica en mantenimiento de redes'
    ]
  },
  {
    titulo: 'Listado de Equipos',
    icon: FiTruck,
    imagen: equiposImg,
    items: [
      'Trailer para Caseta policiales',
      'Plantas de Tratamientos de Aguas Negras',
      'Montacargas 12 Toneladas',
      'Jumbo Komatsu 220PC',
      'Retroexcavadora Jhon Deere 310',
      'Camión Mercedes Benz 711 con plataforma',
      'Compresor de aire con martillo',
      'Máquinas de soldar',
      'Camioneta pickup',
      'Vans de pasajeros',
      'Gandola con batea y/o lowboy',
      'Escarificadora de asfalto',
      'Equipo de colocación de asfalto (finisher, compactador, tampo)',
      'Vacum 160 Barriles',
      'Volquetas 22 m3',
      'Equipo camión Grúa 5 Toneladas',
      'Camión Cesta Aislado certificado por CORPOELEC 25/05/2023',
      'Camión de soldadura',
      'Cámara termografía',
      'Varilla telescópica, mano mecánica',
      'Motosierra, machete, pala draga, barretón',
      'Flejadora, Tijera nicopred, Tijera Yeperadora, cizalla',
      'Rompe Carga',
      'Caja de herramientas de Electricidad',
      'Guantes de Media Tensión',
      'Telurometro, medidor de resistencia de suelo',
      'Eslingas, arnés, guayas'
    ]
  }
];

const Servicios = () => {
  return (
    <section className="py-16 bg-slate-50">
      <div className="container-page">
        <div className="text-center mb-14">
          <p className="eyebrow mb-3">Qué ofrecemos</p>
          <h1 className="section-title">Nuestros Servicios</h1>
        </div>

        <div className="space-y-10">
          {servicios.map((servicio, index) => (
            <article
              key={servicio.titulo}
              className="grid md:grid-cols-2 gap-8 lg:gap-12 items-start rounded-3xl bg-white shadow-card p-6 md:p-10"
            >
              <div className={`overflow-hidden rounded-2xl ${index % 2 === 1 ? 'md:order-2' : ''}`}>
                <img
                  src={servicio.imagen}
                  alt={servicio.titulo}
                  className="w-full h-64 md:h-72 object-cover transition duration-500 hover:scale-105"
                />
              </div>
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 rounded-xl bg-primary-50 text-primary flex items-center justify-center shrink-0">
                    <servicio.icon className="w-6 h-6" />
                  </div>
                  <h2 className="text-2xl font-semibold">{servicio.titulo}</h2>
                </div>
                <ul className="space-y-2.5">
                  {servicio.items.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2.5 text-slate-600">
                      <FiCheck className="w-4 h-4 text-accent-500 mt-1 shrink-0" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Servicios;
